/**
 * @author      yewon@zumper.com (Yewon Lee)
 * @copyright   Copyright (c) 2018, Zumper
 * @description savedSearchesView actions
 */

import { createAction } from 'redux-actions'

import {
  BEGIN_REMOVING_SAVED_SEARCH,
  DESELECT_SAVED_SEARCH,
  ERROR_REMOVING_SAVED_SEARCH,
  GET_ALL_COUNT_SUCCESS,
  GET_COUNT_SUCCESS,
  GET_LISTABLES_ERROR,
  GET_LISTABLES_REQUEST,
  GET_LISTABLES_SUCCESS,
  GET_SAVED_SEARCHES_ERROR,
  GET_SAVED_SEARCHES_REQUEST,
  GET_SAVED_SEARCHES_SUCCESS,
  HIDE,
  HIDE_SUMMARY,
  INCREMENT_LOAD_MORE_COUNT,
  NOT_READY,
  READY,
  RESET_CLUSTERS,
  RESET_LISTABLES,
  RESET_SAVED_SEARCHES_VIEW,
  RESET_SELECTED_SAVED_SEARCH,
  SELECT_ALL,
  SELECT_ONLY_NEW,
  SELECT_SAVED_SEARCH,
  SET_ALL_FILTERS,
  SET_ANALYTIC_CHANNEL,
  SET_HOVERED,
  SET_IMAGES,
  SET_LISTABLES_LIMIT,
  SET_LISTABLES_OFFSET,
  SET_ONLY_NEW_FILTERS,
  SET_ORIGIN,
  SHOW,
  SHOW_SUMMARY,
  SUCCESS_REMOVING,
  SUCCESS_UPDATING,
  UPDATE_SAVED_SEARCHES,
} from '../constants/index'

// counts
export const receiveAllCounts = createAction(GET_ALL_COUNT_SUCCESS)
export const receiveCounts = createAction(GET_COUNT_SUCCESS)

// savedSearches
export const beginLoadingSavedSearches = createAction(GET_SAVED_SEARCHES_REQUEST)
export const errorLoadingSavedSearches = createAction(GET_SAVED_SEARCHES_ERROR)
export const receiveSavedSearches = createAction(GET_SAVED_SEARCHES_SUCCESS)
export const updateSavedSearches = createAction(UPDATE_SAVED_SEARCHES)

// listables
export const beginLoadingListables = createAction(GET_LISTABLES_REQUEST)
export const errorLoadingListables = createAction(GET_LISTABLES_ERROR)
export const incrementLoadMoreCount = createAction(INCREMENT_LOAD_MORE_COUNT)
export const receiveListables = createAction(GET_LISTABLES_SUCCESS)
export const setListablesLimit = createAction(SET_LISTABLES_LIMIT)
export const setListablesOffset = createAction(SET_LISTABLES_OFFSET)

// reset
export const resetClusters = createAction(RESET_CLUSTERS)
export const resetSelected = createAction(RESET_SELECTED_SAVED_SEARCH)
export const resetListables = createAction(RESET_LISTABLES)

// filters
export const setAllFilters = createAction(SET_ALL_FILTERS)
export const setOnlyNewFilters = createAction(SET_ONLY_NEW_FILTERS)

// view
export const showSavedSearchesView = createAction(SHOW)
export const hideSavedSearchesView = createAction(HIDE)

// misc
export const deselect = createAction(DESELECT_SAVED_SEARCH)
export const notReady = createAction(NOT_READY)
export const ready = createAction(READY)
export const select = createAction(SELECT_SAVED_SEARCH)
export const selectAll = createAction(SELECT_ALL)
export const selectOnlyNew = createAction(SELECT_ONLY_NEW)
export const setHovered = createAction(SET_HOVERED)
export const setImages = createAction(SET_IMAGES)
export const showSummary = createAction(SHOW_SUMMARY)
export const hideSummary = createAction(HIDE_SUMMARY)

export const setSavedSearchesViewAnalytic = createAction(SET_ANALYTIC_CHANNEL)
export const setSavedSearchesViewOrigin = createAction(SET_ORIGIN)

export const resetSavedSearchesView = createAction(RESET_SAVED_SEARCHES_VIEW)

export const beginRemoving = createAction(BEGIN_REMOVING_SAVED_SEARCH)
export const successUpdating = createAction(SUCCESS_UPDATING)
export const errorRemoving = createAction<
  unknown, // it's a caught error, which could be anything, so "known to be unknown"
  typeof ERROR_REMOVING_SAVED_SEARCH
>(ERROR_REMOVING_SAVED_SEARCH)
export const successRemoving = createAction<{ searchId: number }, typeof SUCCESS_REMOVING>(
  SUCCESS_REMOVING
)
